import React from 'react';
import {graphql} from "gatsby";
import Markdown from 'markdown-to-jsx';

import Layout from "../../components/layouts/Layout";
import SectionLayoutGrid from "../../components/layouts/SectionLayoutGrid";
import HighlightedCard from "../../components/cards/HighlightedCard";
import FormCLTemplate from "../../components/forms/FormCLTemplate";

import {LottieAnimation} from "../../components/styled/lotti/LottieAnimations";
import {Title} from "../../components/styled/typography/Typography";
import Col from "../../components/styled/grid/Col";

import circuit from "../../../static/assets/animations/circuit/circuit01.json";

const ContentLibraryForm = ({data}) => {

    const {content_library_form} = data;

    return (
        <Layout lang={content_library_form.filters.lang === "hu" ? "hu" : "en"} seo={content_library_form.gated_content.SEO}>
            <LottieAnimation animationData={circuit} left="true"/>
            <SectionLayoutGrid customBackground="middle">
                <Col span={6}>
                    <Title color="white" marginBottom="medium">
                        {content_library_form.title}
                    </Title>
                    <div className="markdown">
                    <Markdown children={content_library_form.gated_content.content} options={{forceBlock: true}}/>
                    </div>
                    <HighlightedCard children={content_library_form.gated_content.highlighted}/>
                </Col>
                <Col span={6}>
                    <FormCLTemplate
                        lang={content_library_form.filters.lang === "hu" ? "hu" : "en"}
                        category={content_library_form.filters.category}
                        image={content_library_form.avatar.url}
                        cldata={content_library_form}
                        list_token={content_library_form.gated_content.list_token}
                    />
                </Col>
            </SectionLayoutGrid>
        </Layout>
    );
};

export const query = graphql`
   query GetSingleContentLibraryForm($slug: String) {
         content_library_form: strapiContentLibraryDownloads(slug: { eq: $slug }) {
          slug
          title
          avatar {
            url
          }
          products {
            name
            slug
          }
          filters {
            category
            lang
            theme
          }
          date(formatString: "LL")
          gated_content {
            content
            highlighted
            list_token
            related {
               id
               slug1
               slug2
               slug3
            }
            SEO {
                title
                isIndexable
                description
                keywords
                preview {
                  url
                }
            }
          }
         }
   }
 `

export default ContentLibraryForm;